import CryptoJS from "crypto-js"
import { CIPHER_KEY } from "../constants/Keys.constants"

/** Encrypt data */
const encrypt = (information: any) => {
    let iv = CryptoJS.enc.Hex.parse('101112131415161718191a1b1c1d1e1f');
  
    const encrptedInfo = CryptoJS.AES.encrypt(JSON.stringify(information), CIPHER_KEY, {
      mode: CryptoJS.mode.CTR,
      iv: iv
    }).toString();
  
    return encrptedInfo;
  };
  

export default encrypt